export default function Footer(){
    return (
        <div className="footer container">
            <div className="footer-section">
                <p className="title">Eat-Hub.com</p>
                <p>Eat-Hub is a place where you can please your soul and tummy with delicious food recepies of all cuisine. And our service is absolutely free.</p>
                <p>&copy; 2024 | All Rights Reserved</p>
            </div>
            <div className="footer-section">
                <p className="title">Contact Us</p>
                <p>soumyaotta11@gmail.com</p>
                <p>+91-8260627567</p>
                <p>2393 Street NYC</p>
            </div>
            <div className="footer-section">
                <p className="title">Socials</p>
                <p>Facebook</p>
                <p>Twitter</p>
                <p>Instagram</p>
            </div>
        </div>
    )
}